<template>
  <div class="admin-images">
    <div class="main" v-bind:class="{ dark: darkmode }">
      <toolbar 
        :loading="false" 
        :info="info_message" 
        :primary_action="navigate_to_new_upload_route"
        :primary_action_text="'Upload'">
      </toolbar>
      <div class="wrap">
        <image-picker :images=images></image-picker>
      </div>
    </div>
  </div>
</template>
<script>
import ImagePicker from '../common/ImagePicker'
import Toolbar from './Toolbar'
export default {
  components: {
    ImagePicker,
    Toolbar
  },
  data: () => {
    return {}
  },
  computed: {
    images() {
      return this.$store.state.images
    },
    info_message() {
      return this.$store.state.images.length + " images available"
    },
    darkmode() {
      return this.$store.state.darkmode
    },
  },
  methods: {
    navigate_to_new_upload_route() {
      this.$router.push({ path: '/admin/images/upload' })
    }
  },
  created: function() {
    this.$store.dispatch('fetchImages').then((data) => {
      // fetched images
    })
  }
}
</script>
